var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 19.0638H61.66V56.8674H7.00391V19.0638Z",
    fill: "url(#paint0_linear_5090_180025)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7789 56.8674H42.8125V31.7916C42.8125 31.0309 43.4292 30.4142 44.1899 30.4142H57.4016C58.1623 30.4142 58.779 31.0309 58.779 31.7916V56.8674H58.7789Z",
    fill: "url(#paint1_linear_5090_180025)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9647 56.8674H44.625V33.5348C44.625 32.8913 45.1468 32.3695 45.7903 32.3695H55.7994C56.443 32.3695 56.9647 32.8913 56.9647 33.5348V56.8674Z",
    fill: "url(#paint2_linear_5090_180025)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0518 30.4143H38.9628C39.8091 30.4143 40.4951 31.1004 40.4951 31.9466V49.4624C40.4951 50.3086 39.8091 50.9947 38.9628 50.9947H10.0518C9.20558 50.9947 8.51953 50.3086 8.51953 49.4624V31.9466C8.51953 31.1004 9.20558 30.4143 10.0518 30.4143Z",
    fill: "url(#paint3_linear_5090_180025)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8692 49.4963H11.1446C10.5771 49.4963 10.1172 49.0364 10.1172 48.4689V32.94C10.1172 32.3725 10.5771 31.9125 11.1446 31.9125H37.8692C38.4366 31.9125 38.8966 32.3725 38.8966 32.94V48.4689C38.8966 49.0364 38.4366 49.4963 37.8692 49.4963Z",
    fill: "url(#paint4_linear_5090_180025)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6605 19.0641V56.8671H36.7196L7.00391 27.1515V19.0641H61.6605Z",
    fill: "url(#paint5_linear_5090_180025)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9253 29.4999H11.4765C8.47566 29.4999 6.04297 27.0672 6.04297 24.0663V19.0638L11.6617 18.8419L17.3589 19.0638V24.0663C17.3589 27.0672 14.9262 29.4999 11.9253 29.4999Z",
    fill: "url(#paint6_linear_5090_180025)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2417 29.4999H22.7929C19.7921 29.4999 17.3594 27.0672 17.3594 24.0664V19.0639L22.8917 18.6201L28.6753 19.0639V24.0664C28.6753 27.0672 26.2426 29.4999 23.2417 29.4999Z",
    fill: "url(#paint7_linear_5090_180025)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5582 29.4999H34.1093C31.1085 29.4999 28.6758 27.0672 28.6758 24.0664V19.0639L34.312 18.6201L39.9917 19.0639V24.0664C39.9917 27.0672 37.559 29.4999 34.5582 29.4999Z",
    fill: "url(#paint8_linear_5090_180025)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8746 29.4999H45.4257C42.4249 29.4999 39.9922 27.0672 39.9922 24.0664V19.0639L45.5691 18.6201L51.3081 19.0639V24.0664C51.3081 27.0672 48.8754 29.4999 45.8746 29.4999Z",
    fill: "url(#paint9_linear_5090_180025)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1871 29.4999H56.7382C53.7374 29.4999 51.3047 27.0672 51.3047 24.0664V19.0639L56.9311 18.6201L62.6206 19.0639V24.0664C62.6206 27.0672 60.1879 29.4999 57.1871 29.4999Z",
    fill: "url(#paint10_linear_5090_180025)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7267 9.06665H17.2474C15.8449 9.06665 14.5434 9.73983 13.8122 10.8437L6.04297 19.0638H17.3589L22.7267 9.06665Z",
    fill: "url(#paint11_linear_5090_180025)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4646 9.06665H22.7272L17.3594 19.0638H28.6753L30.4646 9.06665Z",
    fill: "url(#paint12_linear_5090_180025)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2024 9.06665H30.4651L28.6758 19.0638H39.9917L38.2024 9.06665Z",
    fill: "url(#paint13_linear_5090_180025)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9404 9.06665H38.2031L39.9924 19.0638H51.3082L45.9404 9.06665Z",
    fill: "url(#paint14_linear_5090_180025)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4168 9.06665H45.9375L51.3053 19.0638H62.6212L54.852 10.8437C54.1208 9.73983 52.8193 9.06665 51.4168 9.06665Z",
    fill: "url(#paint15_linear_5090_180025)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7976 58.9334H6.86474C6.48644 58.9334 6.17969 58.6266 6.17969 58.2483V55.5689C6.17969 53.7171 7.68082 52.2159 9.53263 52.2159H59.1297C60.9815 52.2159 62.4827 53.7171 62.4827 55.5689V58.2483C62.4827 58.6266 62.1759 58.9334 61.7976 58.9334Z",
    fill: "url(#paint16_linear_5090_180025)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5090_180025",
    x1: 26.3974,
    y1: 30.0311,
    x2: 54.9055,
    y2: 58.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5090_180025",
    x1: 61.0011,
    y1: 54.2497,
    x2: 35.6674,
    y2: 28.9159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5090_180025",
    x1: 42.6657,
    y1: 36.8305,
    x2: 54.4055,
    y2: 48.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5090_180025",
    x1: 28.4833,
    y1: 49.1819,
    x2: 15.944,
    y2: 22.4458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5090_180025",
    x1: 21.0072,
    y1: 33.2425,
    x2: 32.0445,
    y2: 56.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5090_180025",
    x1: 37.1834,
    y1: 37.0517,
    x2: 29.8726,
    y2: 1.29781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#5C485D",
    stopOpacity: 0.779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5090_180025",
    x1: 9.51007,
    y1: 20.4996,
    x2: 17.8758,
    y2: 28.8654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5090_180025",
    x1: 20.0266,
    y1: 19.6997,
    x2: 26.6869,
    y2: 26.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5090_180025",
    x1: 32.2495,
    y1: 20.6062,
    x2: 39.3169,
    y2: 27.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5090_180025",
    x1: 43.2459,
    y1: 20.2862,
    x2: 50.3778,
    y2: 27.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5090_180025",
    x1: 53.2254,
    y1: 18.9532,
    x2: 62.3001,
    y2: 28.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5090_180025",
    x1: 12.1142,
    y1: 11.7946,
    x2: 18.7767,
    y2: 18.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5090_180025",
    x1: 22.418,
    y1: 11.9929,
    x2: 27.6082,
    y2: 19.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5090_180025",
    x1: 29.8936,
    y1: 10.5197,
    x2: 39.3055,
    y2: 19.9316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5090_180025",
    x1: 40.777,
    y1: 11.0179,
    x2: 47.4013,
    y2: 20.2381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5090_180025",
    x1: 49.4894,
    y1: 11.3116,
    x2: 61.2538,
    y2: 23.0762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5090_180025",
    x1: 34.3312,
    y1: 53.7304,
    x2: 34.3312,
    y2: 58.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.b3c5daf6bdf1f927f9ae335c2af87632.svg";
export { ForwardRef as ReactComponent };